export default __webpack_public_path__ + "static/media/Stave of the Hell Walker.152644d1.jpg";